export default __webpack_public_path__ + "static/media/4E590337-7878-4F7C-8E02-F4FD4AB094C1_1_105_c.f6a3efb0.jpeg";